export default __webpack_public_path__ + "static/media/skip.0898814d.png";